<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12" id="autocomplete_container">
                <h4>Dati progetto</h4>
                <p>Vuoi importare i dati di progetto da un progetto esistente? </p>
                <v-switch
                    v-model="showPrjPicker"
                    label="Seleziona un progetto"
                ></v-switch>
                <v-autocomplete
                    v-if="showPrjPicker"
                    v-model="progetto_obj"
                    persistent-hint
                    :items="items"
                    :loading="isLoading"
                    :search-input.sync="search"
                    item-text="text"
                    item-value="value"
                    attach
                    hint="Scrivi il nome di un progetto già esistente per importare i dati"
                    return-object
                ></v-autocomplete>
            </div>
        </div>

        <div class="row">
            <div class="col-md-5">

                <div class="form-group">
                    <label for="_name">Progetto</label>
                    <input type="text" class="form-control" id="_name" placeholder="nome progetto"
                           v-model="finalData.progetto">
                </div>


            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label for="_fin">Finanziato/Approvato</label>
                    <input type="text" class="form-control" id="_fin" placeholder="indicare ddg, dds ecc."
                           v-model="finalData.finanziato">
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label for="_find">Il</label>
                    <input type="date" class="form-control" id="_find" placeholder="indicare la data"
                           v-model="finalData.finanziato_il">
                </div>
            </div>
        </div>
    </div>

</template>
<script>
var moment = require('moment');
moment.locale("it");

var axios = require('axios');
export default {
    props: {
        "output": "",
        "apiurl": "",
        "source": {
            type: Object,
            default: () => {
            }
        }
    },
    computed: {
        items() {
            return this.entries.map(entry => {
                const _entry = {
                    value: entry.value,
                    fulltext: entry.text,
                    text: entry.text
                };

                _entry.text = entry.text.length > this.descriptionLimit
                    ? entry.text.slice(0, this.descriptionLimit) + '...'
                    : entry.text

                return Object.assign({}, entry, _entry)
            })
        }
    },
    data() {
        return {
            descriptionLimit: 60,
            entries: [],
            isLoading: false,
            search: null,
            "ready": false,
            showPrjPicker: false,
            "progetto_obj":null,
            "finalData": {
                "progetto": "",
                "finanziato": "",
                "finanziato_il": null,
                "progetto_id": null
            },

        }
    },
    watch: {
        finalData: {
            handler(newValue, oldValue) {
                if (this.output) {
                    document.getElementById(this.output).value = JSON.stringify(this.finalData);
                }
            },
            deep: true
        },
        "progetto_obj": function (val) {
            console.log('cambia progetto', val)
            this.finalData.progetto_id = val.value;
            this.finalData.progetto = val.fulltext;
            this.finalData.finanziato = val.ddg;
            this.finalData.finanziato_il = val.ddg_at;
        },
        search(val) {
            console.log('avvia cerca', val)
            if (this.isLoading) return
            this.isLoading = true
            const query = {
                "term": val
            };
            fetch(this.apiurl + "?" + new URLSearchParams(query))
                .then(res => res.json())
                .then(res => {
                    this.entries = res
                })
                .catch(err => {
                    console.log(err)
                })
                .finally(() => (this.isLoading = false))
        },
    },
    mounted() {
        if (this.source) {
            if (this.source.progetto) {
                this.finalData.progetto = this.source.progetto;
            }
            if (this.source.finanziato) {
                this.finalData.finanziato = this.source.finanziato;
            }
            if (this.source.finanziato_il) {
                this.finalData.finanziato_il = this.source.finanziato_il;
            }
            if (this.source.progetto_id) {
                this.finalData.progetto_id = this.source.progetto_id;
            }
        }
        console.log('pronto', this.apiurl);
        this.ready = true;
    }
}

</script>
